import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicGridComponent } from './dynamic-grid.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TailwindToggleComponent } from './toggle-component/tailwind-toggle.component';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [DynamicGridComponent, TailwindToggleComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSortModule,
    FormsModule,
  ],
  exports: [DynamicGridComponent, TailwindToggleComponent],
})
export class DynamicGridModule {}
